module.exports = __webpack_public_path__ + "img/78_20.11982195.png";